// extracted by extract-css-chunks-webpack-plugin
module.exports = {"marginYParts":"markdown-module__marginYParts--H8fnk","marginBHeaders":"markdown-module__marginBHeaders---neii","htmlArea":"markdown-module__htmlArea--T-Toq"};